import { useState } from "react";
import { validateEmail, isNotEmpty } from "../../hooks/validation";
import { useNavigate } from "react-router-dom";
import { useAuthAPI } from "../../hooks/api/use-authAPI";
import { H2, BodyText } from "../../styles/Typography";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import CustomInputText from "../../components/CustomInput/CustomInputText";
import CustomPassword from "../../components/CustomInput/CustomPassword";
import FloatingLogo from "../../components/FloatingLogo/FloatingLogo";
import { IconMail } from "../../assets/icons/Icon";
import {
  Column,
  Container,
  ForgotPasswordText,
  StyledLink,
  StyledButton,
} from "./Login.styles";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isEmailInvalid, setIsEmailInvalid] = useState<boolean>(false);
  const [isPasswordInvalid, setIsPasswordInvalid] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const { handleLogin, toastRef } = useAuthAPI();

  const handleBlurEmail = () => {
    const value = email;
    const isValid = validateEmail(value);
    setIsEmailInvalid(!isValid);
  };

  const handleBlurPassword = () => {
    const value = password;
    const isValid = isNotEmpty(value);
    setIsPasswordInvalid(!isValid);
  };

  const handleSubmit = async () => {
    if (!validateEmail(email) || !isNotEmpty(password)) {
      setIsEmailInvalid(true);
      setIsPasswordInvalid(true);
      return;
    }

    setIsEmailInvalid(false);
    setIsPasswordInvalid(false);
    setIsLoading(true);

    try {
      const success = await handleLogin(email, password);
      if (success) navigate("/");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Column>
      <Toast ref={toastRef} position="bottom-center" />
      <Container>
        <FloatingLogo />
        <H2>Добро пожаловать!</H2>
        <BodyText>Пожалуйста, войдите в систему чтобы продолжить</BodyText>

        <CustomInputText
          value={email}
          setValue={setEmail}
          placeholder="Почта"
          icon={<IconMail size={20} />}
          invalid={isEmailInvalid}
          onBlur={handleBlurEmail}
        />
        <CustomPassword
          value={password}
          setValue={setPassword}
          invalid={isPasswordInvalid}
          onBlur={handleBlurPassword}
        />

        <Button label="Войти" onClick={handleSubmit} loading={isLoading} />
        <ForgotPasswordText>
          Забыли пароль?
          <br />
          {/*  <StyledButton>Восстановить доступ</StyledButton> или{" "} */}
          <StyledLink to="https://t.me/idtechSupport">
            Связаться с поддрежкой
          </StyledLink>
        </ForgotPasswordText>
      </Container>
    </Column>
  );
};

export default Login;
